import { ITEMS_PER_PAGE } from 'core/constants/platform.constants';
import { EApplications } from 'core/model/enums';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IBannersState } from '../types';

export const fetchCreationTabBanners = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchCreationTabBanners`,
  async (platform: EApplications, { getState, rejectWithValue }) => {
    try {
      const { banners } = getState();

      const {
        query,
        target,
        pagination: { currentPage },
      } = banners.creationTab[platform];

      return await apiService.banners.getBannerListByTarget({
        page: currentPage,
        name: query,
        target,
        itemsPerPage: ITEMS_PER_PAGE,
      });
    } catch (error) {
      const errorMessage = handleErrorMessage(error, 'Falló al cargar los banners de la pestaña de creación.');

      notificationService.global.error(errorMessage);

      return rejectWithValue(error);
    }
  },
);

export const fetchCreationTabBannersReducer: TSliceExtraReducer<IBannersState> = builder =>
  builder
    .addCase(fetchCreationTabBanners.pending, (state, action) => {
      const platform = action.meta.arg;

      state.creationTab[platform].loading = true;
    })
    .addCase(fetchCreationTabBanners.rejected, (state, action) => {
      const platform = action.meta.arg;

      state.creationTab[platform].loading = false;

      state.creationTab[platform].banners = [];
    })
    .addCase(fetchCreationTabBanners.fulfilled, (state, action) => {
      const platform = action.meta.arg;

      state.creationTab[platform].loading = false;

      state.creationTab[platform].banners = action.payload.banners;

      state.creationTab[platform].pagination = action.payload.pagination;
    });
